export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const EDIT_ITEM = 'EDIT_ITEM';
export const SET_DELIVERY_TYPE = 'SET_DELIVERY_TYPE';
export const RESET_ITEMS = 'RESET_ITEMS';
